
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine-phx/[brand]/[magazineId]",
      function () {
        return require("private-next-pages/magazine-phx/[brand]/[magazineId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine-phx/[brand]/[magazineId]"])
      });
    }
  